<template>
  <div id="app">
    <!-- 头部 -->
    <div class="header">
      <img class="header-logo" src="./assets/logo.png" alt="">
      <div class="header-title">领智云EMC认证测试数智化平台</div>
    </div>

    <div class="body">
      <div class="system-box">
        <div class="system-list">
          <div class="system-item" v-for="(item, index) in systemList" :key="index" @click="jumpTo(item.systemUrl)">
            <img class="system-item-icon" :src="item.systemIcon"></img>
            <div class="system-item-box">
              <div class="system-item-name">{{ item.systemName }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="set-box">
      <img class="set-icon" src="./assets/setting.png" alt="">
      <div class="set-name">退出登录</div>
    </div>

  </div>
</template>

<script>
import moment from "moment";
moment.locale("zh-cn");
export default {
  name: 'App',
  data() {
    return {
      imgUrl: "http://26.84.0.154",
      fullscreen: false, // 全屏判断
      nowTime: "", // 当前时间
      systemList: [{
        systemIcon: require('./assets/icon1.png'),
        systemName: '实验室驾驶舱',
        systemUrl: 'http://223.111.158.169:58388'
      }, {
        systemIcon: require('./assets/icon2.png'),
        systemName: '自动化测试',
        systemUrl: 'https://intellize.cn:58088'
      }, {
        systemIcon: require('./assets/icon3.png'),
        systemName: '业务平台（无纸化）',
        systemUrl: 'https://intellize.cn:58099'
      }, {
        systemIcon: require('./assets/icon4.png'),
        systemName: '设备管理',
        systemUrl: 'http://223.111.158.169:8899'
      }, {
        systemIcon: require('./assets/icon5.png'),
        systemName: '数据分析与评价',
        systemUrl: 'http://223.111.158.175:8899'
      }, {
        systemIcon: require('./assets/icon6.png'),
        systemName: 'AI助手',
        systemUrl: 'https://home.lightai.com/#/chat/30b28a2267b61127a6d39ea2d6e26556/share?tenant_id=48&type=anonymous&platform=Ai-B2&id=7246454222205665280'
      }, {
        systemIcon: require('./assets/icon7.png'),
        systemName: '数据运维',
        systemUrl: 'http://223.111.158.169:82'
      }, {
        systemIcon: require('./assets/icon8.png'),
        systemName: '区块链',
        systemUrl: 'http://223.111.158.175:9107'
      }], // 系统列表
    }
  },
  created() {
    this.nowTime = new Date().getTime();
    setInterval(() => {
      this.nowTime += 1000;
    }, 1000);

  },
  mounted() {
    // this.load();
    setInterval(() => {
      // this.load();
    }, 1000 * 30);
  },
  filters: {
    dealTime(val, type) {
      var res = moment(val).format(type);

      if (type == "HH:mm:ss") {
        if (
          res == "23:59:59" ||
          res == "06:00:00" ||
          res == "12:00:00" ||
          res == "18:00:00"
        ) {
          try {
            plus.runtime.restart();
          } catch (error) { }
        }
      } else if ('E') {
        let week = parseInt(res);
        let str = '星期';
        switch (week) {
          case 1:
            return str + '一';
          case 2:
            return str + '二';
          case 3:
            return str + '三';
          case 4:
            return str + '四';
          case 5:
            return str + '五';
          case 6:
            return str + '六';
          case 7:
            return str + '日';
        }
      }
      return moment(val).format(type);
    },
  },
  methods: {
    //双击全屏
    allFull() {
      let element = document.getElementById("app");
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
        }
      }
      // 改变当前全屏状态
      this.fullscreen = !this.fullscreen;
    },


    // 跳转页面
    jumpTo(url) {
      if (url) {
        window.location.href = url;
      }
    }

  }
}
</script>

<style lang="scss">
@import "./assets/iconfont/iconfont.css";

* {
  padding: 0;
  margin: 0;
}

html,
body {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

#app {
  width: 100vw;
  height: 100vh;
  background: url('./assets/bg.jpg') no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;

  .header {
    height: 64px;
    width: 100%;
    // background: url('./assets/header-bg.png');
    background-size: 100% 100%;
    display: flex;
    color: #FFF;
    // background: red;
    // opacity: 0.4;

    .header-logo{
      // width: 400px;
      height: 55px;
      margin-top: 10px;
      margin-left: 40px;
    }

    .header-title {
      font-size: 40px;
      font-weight: bold;
      // margin: auto;
      letter-spacing: 6px;
      margin-left: 358px;
      margin-top: 4px;
    }
  }

  .body {
    display: flex;
    margin-top: 100px;
    justify-content: center;

    .system-box {
      width: 1500px;
      // background: #FFF;
      height: 500px;

      .system-list {
        width: 100%;
        display: flex;
        flex-wrap: wrap;

        .system-item {
          width: 336px;
          height: 300px;
          display: flex;
          position: relative;
          justify-content: center;
          margin-bottom: 32px;
          margin-right: 52px;
          cursor: pointer;

          &:nth-child(4n) {
            margin-right: 0px !important;
          }

          .system-item-icon {
            width: 140px;
            height: 130px;
            position: absolute;
            top: 30px;
            z-index: 1;
          }

          .system-item-box {
            width: 100%;
            height: 191px;
            background: url('./assets/system-bg.png') no-repeat;
            background-size: 100% 100%;
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            bottom: 0;

            .system-item-name {
              font-size: 32px;
              margin-top: 42px;
              font-weight: bold;
              text-align: center;
              color: #FFF;
            }
          }
        }
      }
    }
  }

  .set-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: fixed;
    right: 20px;
    bottom: 20px;
    cursor: pointer;

    .set-icon {
      width: 70px;
      height: 70px;
    }

    .set-name {
      color: #FFF;
      font-size: 14px;
      margin-top: 12px;
    }
  }

}
</style>